import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Page from "../../helpers/config";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import DataTableBase from "../common/DataTableBase";
import { ConvertToDMYHIS } from "../../helpers/uttils";
import Link from "../common/Link";
import { Button, Form } from "react-bootstrap";
import ModalPopup from "../common/Modal";
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import deleteGif from "../../assets/gifs/delete.gif";
import noteIcon from "../../assets/Icons/note.svg";

const SchoolNotes = ({ boardMemberId }) => {
  const [open, setOpen] = useState(false);
  const [modalChatView, setmodalChatView] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setperPage] = useState(Page.records);
  const [currentPage, setcurrentPage] = useState(1);
  const [Data, setData] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(true);
  const [modalForm, setModalForm] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formdata, setFormdata] = useState({
    subject: "",
    description: "",
    file: "",
  });
  const [noteIdToDelete, setNoteIdToDelete] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  console.log(Data, "Data");

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setperPage(newPerPage);
    setcurrentPage(page);
    setRefresh(!refresh);
  };

  const handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFormdata({ ...formdata, file: file });
    }
  };

  const handlePageChange = (page) => {
    setcurrentPage(page);
    setRefresh(!refresh);
  };

  const onAddNote = (e) => {
    e.preventDefault();
    setIsloading(true);

    Postdata(HttpService.board_notes_add, {
      ...formdata,
      member_id: boardMemberId,
    }).then((res) => {
      if (res.status === 200) {
        setModalForm(false);
        setRefresh(!refresh);
        setSelectedFile(null);
      }
      dispatch(message(res.message));
    });
    setIsloading(false);
  };

  const noteData = () => {
    setIsloading(true);
    Postdata(HttpService.school_notes_list, {
      page: currentPage,
      perpage: perPage,
      member_id: boardMemberId,
      startDate: startDate,
      endDate: endDate,
    })
      .then((response) => {
        if (response.status === 200) {
          setData(response?.data?.notes);
          setTotalRows(response.data.count);
          setIsloading(false);
        } else {
          setIsloading(false);
          dispatch(message(response.message));
        }
      })
      .catch((e) => {
        setIsloading(false);
        dispatch(message(e.message));
      });
  };

  const handleDelete = (id) => {
    setIsloading(true);
    Postdata(HttpService.school_notes_delete, { id: id })
      .then((response) => {
        if (response.status === 200) {
          setRefresh(!refresh);
          dispatch(message(response.message));
        } else {
          dispatch(message(response.message));
        }
        setIsloading(false);
      })
      .catch((e) => {
        setIsloading(false);
        dispatch(message(e.message));
      });
  };

  const eachNoteData = (id) => {
    setIsloading(true);
    Postdata(HttpService.school_notes_show, {
      id: id,
    })
      .then((response) => {
        if (response.status === 200) {
          setFormdata({
            id: response.data._id,
            subject: response.data.subject,
            description: response.data.description,
            file: response.data.file,
          });
          setIsloading(false);
        } else {
          setIsloading(false);
          dispatch(message(response.message));
        }
      })
      .catch((e) => {
        setIsloading(false);
        dispatch(message(e.message));
      });
  };

  useEffect(() => {
    noteData();
    console.log("formdata >>>>", formdata);
    console.log("startDate, endDate >>>>", startDate, endDate);
  }, [refresh]);
  
  return (
    <>
      <ModalPopup
        className="alert-box-popup"
        show={modalForm}
        size="md"
        onHide={() => {
          setModalForm(false);
          setNoteIdToDelete(null);
        }}
        onExited={() => setNoteIdToDelete(null)}
      >
        {/* <i className="mdi mdi-information-outline"></i> */}
        <div className="text-center flex justify-center flex-col items-center gap-3 px-3 ">
          <h3>Delete Note</h3>
          <img src={deleteGif} className="w-[120px] " alt="del" />
          <p className="text-card-body">
            Are you sure you want to delete this note? It will erase all the
            data permanently.
          </p>
          <div className="w-full flex justify-between gap-3 mb-2">
            <button
              className="bg-secondary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
              onClick={() => {
                handleDelete(noteIdToDelete);
                setModalForm(false);
              }}
            >
              Yes, Delete
            </button>
            <button
              className="bg-primary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
              onClick={() => setModalForm(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </ModalPopup>
      {/* <div className="col-lg-12 text-end">
          <Button onClick={() => setModalForm(true)} className="btn btn-custom">
            Add Note
          </Button>
        </div> */}
      {/* <div className="row mb-3">
          <div className="col-md-3">
            <Form.Group>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  setRefresh(!refresh);
                }}
              />
            </Form.Group>
          </div>
          <div className="col-md-3">
            <Form.Group>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  setRefresh(!refresh);
                }}
              />
            </Form.Group>
          </div>
          <div className="col-lg-6 d-flex align-items-end justify-content-end"></div>
        </div> */}

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Data?.map((subject, index) => (
          <div
            key={index}
            className="relative bg-white p-[15px] rounded-xl hover:shadow-lg transition"
          >
            {/* Three Dots Menu */}
            <div className="absolute top-3 right-3">
              <button onClick={() => toggleMenu(index)}>
                <img
                  src={HiOutlineDotsVertical}
                  className="text-gray-500 hover:text-black"
                />
              </button>

              {openMenuIndex === index && (
                <div className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10">
                  <button className="block w-full text-left px-3 rounded-t-xl py-2 text-sm hover:bg-gray-100">
                    Edit
                  </button>
                  <button
                    className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                    onClick={() => {
                      setNoteIdToDelete(subject._id);
                      setModalForm(true);
                    }}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>

            {/* Title & Description */}
            <div className="mb-4">
              <h3 className="font-semibold text-card-title text-gray-800 flex gap-2">
                <img src={noteIcon} alt="noteIcon" />
                {subject.subject}
              </h3>
              <p className="mt-1 text-card-body text-gray-600 line-clamp-3 ">
                {subject.description}
              </p>
            </div>

            {/* PDF Icons */}
            <div className="flex gap-1">
              {subject.file?.map((fileUrl, i) => (
                <a
                  key={i}
                  href={fileUrl}
                  download // triggers direct download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs bg-red-600 text-white px-2 py-1 rounded-full font-semibold hover:bg-red-700 transition"
                >
                  PDF
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SchoolNotes;

//   <ModalPopup
//         className="alert-box-popup"
//         show={modalForm}
//         size="lg"
//         onHide={() => setModalForm(false)}
//         onExited={() =>
//           setFormdata({
//             subject: "",
//             description: "",
//             file: "",
//           })
//         }
//         heading={`${formdata.id ? "Update" : "Add"} Note`}
//       >
//         {/* <i className="mdi mdi-information-outline"></i> */}
//         <form onSubmit={onAddNote} className="text-start">
//           <Form.Group className="form-group">
//             <Form.Label>
//               Subject<span style={{ color: "red" }}>*</span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               value={formdata.subject}
//               onChange={(e) =>
//                 setFormdata({ ...formdata, subject: e.target.value })
//               }
//               required
//             />
//           </Form.Group>
//           <Form.Group className="form-group">
//             <Form.Label>
//               Description<span style={{ color: "red" }}>*</span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               as="textarea"
//               rows={4}
//               value={formdata.description}
//               onChange={(e) =>
//                 setFormdata({ ...formdata, description: e.target.value })
//               }
//               required
//             />
//           </Form.Group>

//           <Form.Group className="form-group">
//             <Form.Label>
//               File{!formdata.id && <span style={{ color: "red" }}>*</span>}
//             </Form.Label>
//             <Form.Control
//               type="file"
//               accept=".pdf,.doc,.docx,.txt"
//               required={!formdata.id}
//               onChange={handleImagePreview}
//             />
//             {/* <small>Photo need to be 1029 X 452 pixels.</small> */}
//             {/* Show existing file from API */}
//             {formdata.file && typeof formdata.file === "string" && (
//               <div className="mt-2">
//                 <strong>Existing File:</strong>{" "}
//                 <a
//                   href={formdata.file}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   {formdata.file.split("/").pop()}
//                 </a>
//               </div>
//             )}
//             {/* show new file preview */}
//             {selectedFile && (
//               <div className="mt-2">
//                 <strong>Selected File:</strong> {selectedFile.name} <br />
//                 <strong>Size:</strong> {(selectedFile.size / 1024).toFixed(2)}{" "}
//                 KB
//               </div>
//             )}
//           </Form.Group>

//           <button
//             className="btn btn-primary"
//             type="submit"
//             disabled={isLoading}
//           >
//             {isLoading ? "Please wait..." : formdata.id ? "Update" : "Submit"}
//           </button>
//           <button
//             className="btn btn-danger"
//             type="button"
//             onClick={() => setModalForm(false)}
//           >
//             Cancel
//           </button>
//         </form>
//         <div className="actions">
//           {/* <button className="btn btn-primary" onClick={() => LogoutCallApi()}>Logout</button>
//                     <button className="btn btn-danger" onClick={() => setmodalLogout(false)}>Cancel</button> */}
//         </div>
//       </ModalPopup>
